import BasicResources from './basic-resources';

// The Resources class provides a set of static fields, one for each resource
// needed by the application. Users should generally call its initialise() method, to set
// up the environment and create all of the resources the application will use.

// In some (hopefully, rare) situations, it may be required that the environment is provided
// from a parent application. In these situations, call createResources(parentEnv) directly,
// and pass it the Resources.env object that is the environment required.
class Resources {
    // createResources() should create a static field for each resource:
    //
    //    const env = parentEnv || Resources.env;
    //
    //    Resources.colours = env.resource('Colours')
    //                           .baseUrl('@AvatarAdminBaseUrl')
    //                           .service('colours');
    //
    //
    // Application code can then access those resources like so:
    //
    //    const allColours = Resource.colours.get().send();

    static createResources(parentEnv) {
        if (parentEnv) {
            Resources.env = parentEnv;
        }

        Resources.getTeacherClassMgmtData = Resources.env.resource('getTeacherClassMgmtData')
            .baseUrl('@ClassManagerApi')
            .service('teacher-classes/products/{productId}');
        Resources.getTeacherClassMgmtClasses = Resources.env.resource('getTeacherClassMgmtClasses')
            .baseUrl('@ClassManagerApi')
            .service('teacher-classes/classes/{classId}/products/{productId}');
        Resources.getTeacherClassMgmtGroups = Resources.env.resource('getTeacherClassMgmtGroups')
            .baseUrl('@ClassManagerApi')
            .service('teacher-classes/classes/{classId}/groups/{groupId}/products/{productId}');
        Resources.getTeacherClassMgmtUnassignStudent = Resources.env.resource('getTeacherClassMgmtUnassignStudent')
            .baseUrl('@ClassManagerApi')
            .service('teacher-classes/');
        Resources.getTeacherClassMgmtUpdatePassword = Resources.env.resource('getTeacherClassMgmtUpdatePassword')
            .baseUrl('@ClassManagerApi')
            .service('teacher-classes/students/password');

        Resources.getStudentManagementData = Resources.env.resource('getStudentManagementData')
            .baseUrl('@ClassManagerApi')
            .service('student-management/products/{productId}');
        Resources.getStudentManagementClasses = Resources.env.resource('getStudentManagementClasses')
            .baseUrl('@ClassManagerApi')
            .service('student-management/products/{productId}/classes/{classId}');
        Resources.getStudentManagementGroups = Resources.env.resource('getStudentManagementGroups')
            .baseUrl('@ClassManagerApi')
            .service('student-management/products/{productId}/classes/{classId}/groups/{groupId}');
        Resources.assignStudents = Resources.env.resource('assignStudents')
            .baseUrl('@ClassManagerApi')
            .service('student-management/products/{productId}/classes/{classId}/groups/{groupId}/students/assign');
        Resources.unassignStudents = Resources.env.resource('unassignStudents')
            .baseUrl('@ClassManagerApi')
            .service('student-management/products/{productId}/classes/{classId}/groups/{groupId}/students/unassign');
        Resources.getStudentManagementAvailableClasses = Resources.env.resource('getStudentManagementAvailableClasses')
            .baseUrl('@ClassManagerApi')
            .service('student-management/products/{productId}/available-classes/{classId}');
        Resources.getStudentManagementAvailableGroups = Resources.env.resource('getStudentManagementAvailableGroups')
            .baseUrl('@ClassManagerApi')
            .service('student-management/products/{productId}/available-classes/{classId}/groups/{groupId}');
        Resources.downloadStudentSignInCards = Resources.env.resource('downloadStudentSignInCards')
            .baseUrl('@SignInCardGatewayUrl')
            .service('api/v1/products/{productId}/studentSignInCards');
    }


    // Initialise the environment and resources, based on the provided
    // environment name.  We return the environment so the caller has
    // access to everything, in particular the authToken if one was
    // passed in the query parameters.

    static initialise(envName, credentials) {
        Resources.env = BasicResources.initialise(envName, credentials);

        Resources.createResources();

        return Resources.env;
    }
}

export default Resources;




// WEBPACK FOOTER //
// ./helpers/resources.js